import Vue from 'vue'
import Store from 'store'
import ProductInfo from './ProductInfo.vue'

const el = '.nti-component--product-info'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        new Vue({
            store: Store,
            el,
            components:{
                ProductInfo
            },
            template: '<ProductInfo />'
        })
    }
}

export default {
    render
}